import { render, staticRenderFns } from "./ManagerDocumentManager.vue?vue&type=template&id=2c90e03c&scoped=true&"
import script from "./ManagerDocumentManager.vue?vue&type=script&lang=js&"
export * from "./ManagerDocumentManager.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/manager-document-manager.scss?vue&type=style&index=0&id=2c90e03c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90e03c",
  null
  
)

export default component.exports